Alpine.data('alpine_email_subscribe', () => ({
  formData: {
    email: '',
  },
  error: null,
  loading: false,
  subscribed: false,
  hasError() {
    return this.error !== null;
  },
  isLoading() {
    return this.loading;
  },
  isSubscribed() {
    return this.subscribed;
  },
  submit(e) {
    if(this.loading || this.subscribed) {
      return;
    }

    this.error = null;
    this.loading = true;

    window.axios
      .post(e.target.getAttribute('action'), this.formData)
      .then(response => this.subscribed = true)
      .catch(error => {
        let message = (error.response || {}).data;

        if(message) {
          this.error = message;
          return;
        }

        this.error = 'There was a problem subscribing to the newsletter.';
      })
      .finally(() => this.loading = false);
  },
}));
